import axiosInstance from '../axiosInterceptor/axiosInstance'

const removeTeamFromGroup = async ({ orgId, groupId, seasonTeamId }) => {
  const url = `v1/orgs/${orgId}/season-teams/${seasonTeamId}/groups/${groupId}`
  const response = await axiosInstance.delete(url)
  return response?.data
}

export default removeTeamFromGroup
